import axios from 'axios';

const API_URL = process.env.VUE_APP_API_URL;

export default new (class {
	async getAll(facilityId) {
		const response = await axios.get(
			`${API_URL}/api/Cms/Users?facilityId=${facilityId}`,
			{
				withCredentials: true,
				headers: {
					'Cache-control': 'no-cache'
				}
			}
		);
		return response.data;
	}
	async getById(facilityId, UserId) {
		const url = UserId
			? `/api/Cms/User?facilityId=${facilityId}&id=${UserId}`
			: `/api/Cms/User?facilityId=${facilityId}`;

		const response = await axios.get(`${API_URL}${url}`, {
			withCredentials: true,
			headers: {
				'Cache-control': 'no-cache'
			}
		});
		return response.data;
	}
	async update(UserData) {
		try {
			await axios.put(`${API_URL}/api/Cms/User`, UserData, {
				withCredentials: true,
				headers: {
					'Cache-control': 'no-cache'
				}
			});
		} catch (error) {
			console.error('Error :', error);
			throw error;
		}
	}
	async deleteById(UserId) {
		try {
			await axios.delete(`${API_URL}/api/Cms/User?id=${UserId}`, {
				withCredentials: true,
				headers: {
					'Cache-control': 'no-cache'
				}
			});
		} catch (error) {
			console.error('Error deleting by ID:', error);
			throw error;
		}
	}
})();
